import React from "react";
import { useNavigate } from "react-router-dom";
import { Home, ArrowLeft, Building2 } from "lucide-react";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <section className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-100 flex items-center justify-center px-4 sm:px-6">
      
      <div className="w-full max-w-5xl bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-200">
        
        <div className="grid grid-cols-1 md:grid-cols-2">
          
          {/* CONTENT */}
          <div className="p-8 sm:p-12 lg:p-16 flex flex-col justify-center">
            
            <span className="inline-flex items-center gap-2 text-xs sm:text-sm font-semibold text-gray-700 bg-gray-100 px-3 py-1 rounded-full w-fit">
              <Building2 className="w-4 h-4" />
              404 Error
            </span>

            <h1 className="mt-4 text-4xl sm:text-5xl lg:text-6xl font-extrabold text-gray-900 leading-tight">
              Property <span className="text-blue-600">not found</span>
            </h1>

            <p className="mt-4 text-sm sm:text-base text-gray-600 max-w-md leading-relaxed">
              The page you're looking for might have been removed, renamed, or is temporarily unavailable. Let’s help you find the right property.
            </p>

            {/* ACTIONS */}
            <div className="mt-8 flex flex-col sm:flex-row gap-3 sm:gap-4">
              
              <button
                onClick={() => navigate("/")}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 rounded-lg bg-blue-600 text-white text-sm sm:text-base font-semibold hover:bg-blue-700 shadow-md transition-all active:scale-95"
              >
                <Home className="w-4 h-4 sm:w-5 sm:h-5" />
                Go to Home
              </button>

              <button
                onClick={() => navigate(-1)}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 rounded-lg border-2 border-blue-600 text-blue-700 text-sm sm:text-base font-semibold hover:bg-blue-50 transition-all active:scale-95"
              >
                <ArrowLeft className="w-4 h-4 sm:w-5 sm:h-5" />
                Go Back
              </button>

            </div>
          </div>

          {/* VISUAL */}
          <div className="hidden md:flex flex-col items-center justify-center bg-gradient-to-br from-blue-100 to-indigo-200 relative overflow-hidden">
            
            {/* Glow effects */}
            <div className="absolute top-[-10%] right-[-10%] w-64 h-64 bg-white/30 rounded-full blur-3xl"></div>
            <div className="absolute bottom-[-10%] left-[-10%] w-64 h-64 bg-blue-300/30 rounded-full blur-3xl"></div>

            <div className="relative text-center px-6 z-10">
              
              <div className="text-[110px] lg:text-[140px] select-none filter drop-shadow-lg">
                🏢
              </div>

              <h2 className="text-2xl font-bold text-blue-900 mt-4">
                Find Your Dream Property
              </h2>

              <p className="mt-1 text-blue-800/70 font-medium">
                Explore verified listings and trusted deals.
              </p>

            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default NotFound;